import React from "react";
import thumbsUpIcon from "../../assets/thumbsUpIcon.svg";
import { SecondaryButton } from "../form/secondary-button";
import { PrimaryButton } from "../form/primary-button";
import { AppRouteNames } from "../../routes/app-routes";

const baseURL = window.location.origin;

const AddUserBottomSheetContent = ({ data, onCopy, onClose, success }) => (
  <>
    <div className="flex flex-col items-center justify-center text-black">
      <span className="text-pepper text-2xl  mb-3 text-center font-headings-primary">
        User created
      </span>
      <span className="text-pepper text-center mb-6 font-body-primary ">
        Share the login details with the user.
        <p className="mt-2"><strong>User name: {data?.Email || "user email"}</strong></p>
        <p className="mt-2"><strong>Portal: {baseURL}</strong></p>
      </span>
    </div>
    <div className="flex flex-col justify-between items-center mt-2">
      <span className="text-black items-start w-full mb-2">Temporary Password</span>
      <div className="bg-gray-100 p-2 rounded mb-4 w-full text-center flex justify-between items-center">
        <span className="text-base text-black ">{data?.TempPassword || "password"}</span>
        <SecondaryButton
          type="button"
          onClick={onCopy}
          className="!w-[20%] ml-2 px-2 py-1 !bg-gray-100 !text-black !border !border-gray-100 hover:bg-gray-100 "
        >
          Copy
        </SecondaryButton>
      </div>
      <PrimaryButton
        type="button"
        onClick={onClose}
        className="w-full bg-black border border-pepper hover:bg-pepper "
      >
        Close
      </PrimaryButton>
    </div>
  </>
);

export default AddUserBottomSheetContent;
